import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import Status from 'components/field/Status';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';
import * as F from 'components/form/FormLayout.styled';
import ConfirmationModal from 'components/global/ConfirmationModal';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import { updateDynamicListsInPage } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { OTO_LINK } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { faSave } from '@fortawesome/pro-solid-svg-icons';

const defaultColSpan = {
	md: 6
};

const CancelOTOLinkOrderForm = NiceModal.create(({ otoOrderIDs, orderIDs }) => {
	const { showError, showSuccess } = useAlert();

	const [isLoading, setIsLoading] = useState(false);

	const axios = useAxiosPrivate();
	const modal = useModal();
	const dispatch = useDispatch();

	const formatOrderIDs = useMemo(() => {
		return orderIDs?.join?.(', ');
	}, [orderIDs]);

	const onSubmit = () => {
		setIsLoading(true);
		axios
			.post(OTO_LINK.CANCEL_OTO_LINK_ORDER, {
				otoOrderIDs
			})
			.then((response) => {
				if (response.status === 200) {
					showSuccess({});
					dispatch(updateDynamicListsInPage());
				} else {
					throw new Error(response);
				}
			})
			.catch((error) => {
				showError();
				AppLogger.error(error);
			})
			.finally(() => {
				setIsLoading(false);
				modal.remove();
			});
	};

	const handleCancel = () => {
		NiceModal.show(ConfirmationModal, {
			yesAction: () => {
				modal.remove();
			}
		});
	};

	return (
		<Modal fullwidth maxWidth="medium" className="modal-OTOLink-cancelOrder">
			<ModalTitle>
				<Typography variant="p1">cancelOrder</Typography>
			</ModalTitle>
			<ModalContent>
				<F.Form>
					<FormItem label="status" colSpan={defaultColSpan}>
						<Status name="status" value="canceled" />
					</FormItem>

					<FormItem label="orderNumbers" colSpan={defaultColSpan}>
						<StringInput value={formatOrderIDs} disabled />
					</FormItem>
				</F.Form>
			</ModalContent>
			<ModalActions>
				<Button variant="outline" label="cancel" onClick={handleCancel} />
				<Button icon={faSave} variant="blue" label="save" onClick={onSubmit} loading={isLoading} />
			</ModalActions>
		</Modal>
	);
});

export default CancelOTOLinkOrderForm;
